import { Api } from "./Api";

export default {
  getClientSegments(params, headers = {}) {
    return Api.get("/v1/segments/get" + params, { headers: headers });
  },
  get(params, json = {}) {
    return Api.get("/v1/segments/get" + params, json);
  },
  delete(segmentId) {
    return Api.delete("/v1/segments/" + segmentId);
  },
  store(json, headers = {
    Accept: "application/json",
  }) {
    return Api.post("/v1/segments", json, {
      headers: headers
    });
  },
  update(segmentId, json) {
    return Api.put("/v1/segments/" + segmentId, json);
  },
  getSegJs(id) {
    return Api.get("/v1/segments/get_js_seg/" + id)
  },
  executeQueryField(website_id, limit, additionalParams = "", query, headers) {
    return Api.post(`/v1/segments/executeQueryField/${website_id}?limit=${limit}` + additionalParams, query, {
      headers: headers
    })
  },
  getAudCount(website_id, query) {
    return Api.post(`/v1/segments/executeQueryField/${website_id}?count=true`, query)
  }
};
